function trimValue(value) {
    if (value === undefined || value === null) {
        return '';
    }
    return String(value).trim();
}

function extractSuffix(value) {
    const normalized = trimValue(value);
    if (!normalized) {
        return '';
    }
    const compact = normalized.replace(/\s+/g, '');
    if (compact.length <= 4) {
        return compact;
    }
    return compact.slice(-4);
}

export function formatUserDisplayName(user, fallbackPrefix = '囊友') {
    const target = user || {};
    const nickName = trimValue(target.nickName || target.nickname);
    if (nickName) {
        return nickName;
    }
    const suffix = extractSuffix(target.userNumber || target.user_number || target.userId || target.user_id);
    return suffix ? `${fallbackPrefix}${suffix}` : fallbackPrefix;
}

